import { render, staticRenderFns } from "./DetailShare.vue?vue&type=template&id=22ea88cc&scoped=true&"
import script from "./DetailShare.vue?vue&type=script&lang=js&"
export * from "./DetailShare.vue?vue&type=script&lang=js&"
import style0 from "./DetailShare.vue?vue&type=style&index=0&id=22ea88cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea88cc",
  null
  
)

export default component.exports